'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import Link from '@eliadmin/core/src/components/link';

import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

import { MdOutlineShoppingCart } from 'react-icons/md';

export type HeaderCartButtonProps = {
  className?: {
    root?: string;
    info?: string;
    title?: string;
    price?: string;
    badge?: string;
  };
};

export function HeaderCartButton({ className }: HeaderCartButtonProps) {
  const systemLabels = useSystemLabels();
  const { data: cart } = useQuery(useCartQueryOpts());

  return (
    <Link aria-label={systemLabels('cart')} href={ROUTES.CART()} prefetch={false}>
      <Button
        asChild
        size={'custom'}
        className={cn(
          'w-fit text-center',
          'h-6 w-6 rounded-none bg-transparent !p-0 shadow-none transition-all hover:bg-transparent hover:opacity-80',
          'ea-cart-button',
          className?.root,
        )}
      >
        <div data-ea-visual-tag="button">
          <div className="relative">
            {<MdOutlineShoppingCart className="h-6 w-6" color="black" />}

            <CartBadge
              className={cn(className?.badge)}
              variant={HEADER_CONFIG.headerMain.cart.badgeVariant}
            />
          </div>
        </div>
      </Button>
    </Link>
  );
}
